<script>
export default {
  name: 'AnalyticsKeywordsReport',
  props: {
    data: Object,
    loading: Boolean
  },
  computed: {
    tableData() {
      const report = this.data;

      if (report) {
        const totalVisits = report.totalsForAllResults['ga:visits'];
        const tableData = report.rows.map(row => ({
          keyword: row[0],
          visits: parseFloat(row[1]).toLocaleString(),
          visitsPercentage: (parseFloat(totalVisits > 0 ? row[1] / totalVisits : 0) * 100).toFixed(1).toLocaleString()
        }));

        return tableData;
      } else {
        return [];
      }
    }
  }
};
</script>

<template>
  <el-table v-loading="loading" :data="tableData">
    <el-table-column :label="$t('Keywords')" prop="keyword" />
    <el-table-column :label="$t('Visits')" prop="visits" />
    <el-table-column label="%" prop="visitsPercentage" />
  </el-table>
</template>
